import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";

interface ConfirmDialogProps {
  open: boolean;
  confirmId: string;
  title: string;
  text: string;
  onOpenChange: (open: boolean) => void;
  onConfirm: (confirmId: string) => void;
}

export const ConfirmDialog = ({
  confirmId,
  title,
  text,
  open,
  onOpenChange,
  onConfirm,
}: ConfirmDialogProps) => {

  const handleConfirm = () => {
    onConfirm(confirmId);
    handleClose();
  };

  const handleClose = () => {
    onOpenChange(false);
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      title={title}
      footer={
        <div className="flex justify-end gap-4 pb-2 pr-2">
          <Button variant="outlined" onClick={() => handleClose()}>
            Avbryt
          </Button>
          <Button onClick={handleConfirm}>
            Bekräfta
          </Button>
        </div>
      }
    >
      <span className="text-sm text-gray-600">
        {text}
      </span>
    </Dialog >
  );
};